.root {
  overflow: hidden;
  border: 1px solid var(--color-code-border);
  border-radius: var(--radius-lg);
  background: var(--color-code-background) !important;
  color: var(--color-code-foreground);
  color-scheme: dark;
  scrollbar-color: var(--color-code-muted) var(--color-code-background);
  box-shadow: var(--shadow-xs);
}

// The tabs, and an optional link at the bar's end.
.tabBar {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
  border-bottom: 1px solid var(--color-code-border);
  background: var(--color-code-background-raised);
}

.tabList {
  // The surrounding bar draws the divider using the code palette.
  border-bottom: 0;
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  scrollbar-color: var(--color-code-muted) var(--color-code-background-raised);
  padding-inline: 0.25rem;
  background: var(--color-code-background-raised) !important;
  color: var(--color-code-muted);
}

.tabLink {
  flex-shrink: 0;
  margin-inline-end: 0.875rem;
  color: var(--color-code-foreground);
  font-size: 0.8125rem;
  white-space: nowrap;
}

.tab {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent !important;
  color: inherit !important;
}

.tab:hover {
  background: color-mix(in srgb, var(--color-code-foreground) 6%, transparent) !important;
  color: var(--color-code-foreground);
}

.tab[data-active] {
  background: transparent !important;
  color: var(--color-code-foreground) !important;
}

.editor {
  width: 100%;
  border: 0 !important;
  border-radius: 0 !important;
  background: var(--color-code-background) !important;
}

.companion {
  border: 0 !important;
  border-top: 1px solid var(--color-code-border) !important;
  border-radius: 0 !important;
  margin-top: 0.5rem;
}

.codeSection + .codeSection {
  border-top: 1px solid var(--color-code-border);
}

.codeHeading {
  display: inline-flex;
  margin: 1rem 1rem 0;
  color: var(--color-code-foreground);
  font-size: 0.875rem;
  font-weight: 500;
}
